export default __webpack_public_path__ + "static/media/pause.6b10603a.svg";